import React from 'react'
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const RajgirResidency = () => {
    const carouselRajgirResidency = {
 items: 1,
        loop: true,
        dots: false,
        margin: 0,
        autoplay: true,
        nav: true,
        navText: ['<i class="ti-angle-left" aria-hidden="true"></i>', '<i class="ti-angle-right" aria-hidden="true"></i>'],
        responsiveClass: true,
        responsive: {
            0: {
                dots: false,
            },
            600: {
                dots: false,
            },
            1000: {
                dots: false,
            }
        }
};
    const carouselSravastiResidencythumb = {
  loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
};
  return (
        <>
        <header class="headerslider">       
             <OwlCarousel className="owl-theme first-carousel" {...carouselRajgirResidency}>
                <div className='item'>
                    <img src='img/slider/Rajgir-slider-1.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                <div className='item'>
                    <img src='img/slider/Rajgir-slider-2.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>

             </OwlCarousel>
                  
       
        <Link to="#" data-scroll-nav="1" class="mouse smoothscroll"> <span class="mouse-icon">
                <span class="mouse-wheel"></span> </span>
        </Link>
    </header>
    
    <section class="room-details1 section-padding" data-scroll-index="1">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-title">The Rajgir Residency</div>
                </div>
                <div class="col-md-8">
                      <p>An Exemplary Piece Of Architecture With Well Appointed 82 Rooms And All Modern Amenities Of Comfort And Luxury. Our property has 79 deluxe double and 3 suite rooms.  Located in Rajgir, District Nalanda, Bihar, Our property is nestled amidst mountains on 5 sides offering a great resort view. Just 10 Minutes Drive From 'Gridhakuta Hill', (Vulture' Peak) adding To Excellence In Luxury Is The Indian, Korean, Thai, Japanese, Chinese and special Vietnamese Cuisine Available Here. </p>
                      <p>Rajgir, a sacred site in Buddhism, was a significant destination for Lord Buddha's teachings. The city is home to Nature safari, zoo safari, Bimbisara Jail, Vishwa Shanti stupa, Venuvana, and other ancient sites holding deep spiritual significance.</p>
                      <p>Rajgir holds significance in Jainism as well. According to Jain tradition, Lord Mahavira, the 24th
                         Jain Tirthankara, visited Rajgir several times and spent time meditating and teaching in the region.
                          The city is mentioned in Jain scriptures as a place where Lord Mahavira delivered sermons and 
                          interacted with his followers. We being the only hotel with a swimming pool in the entire city, are also located at a walking distance from venuvan and hot springs making it a prime stay. We also have lawns and halls which fulfill the marriage ceremonial needs along with safe facility available in all the rooms.</p>
                      <p>At The Rajgir Residency, we blend modern comforts with a deep connection to the region's cultural 
                        legacy. Join us for a journey of discovery, reflection, and tranquility in this historic city. The Hotel is Recognized by Department of Tourism, Government of Bihar and We are also Members of FHRAI and HRAEI.</p>
                    <p></p>
                    <div class="row">
                        <div class="col-md-6">
                            <h6>Check-in</h6>
                            <ul class="list-unstyled page-list mb-30">
                                <li>
                                    <div class="page-list-icon"> <span class="ti-check"></span> </div>
                                    <div class="page-list-text">
                                        <p>Check-in - 2 PM</p>
                                    </div>
                                </li>
                               
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <h6>Check-out</h6>
                            <ul class="list-unstyled page-list mb-30">
                                <li>
                                    <div class="page-list-icon"> <span class="ti-check"></span> </div>
                                    <div class="page-list-text">
                                        <p>Check-out - 12 Noon</p>
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                        <div className="col-md-12">
                                <div className="cont">
                                    <h3>Addres</h3>
                                    <p>Rajgir, Dist - Nalanda - 803116, Bihar (India)<br />
                                        <strong>Mob. No.</strong>: <a href='tel:+91 92893 00354'> +91 92893 00354</a><br />
                                        <strong>Tel No.</strong> : <a href='tel:+91 6112 - 255404'>+91 6112 - 255404, 255405</a><br />
                                        <strong>Email</strong> : <a href='mailto:therajgirresidency@gmail.com'>therajgirresidency@gmail.com,</a> <br />
                                        </p>
                                </div>
                            </div>

                    </div>
                </div>
                <div class="col-md-3 offset-md-1">
                    <h6>Facilities of The Rajgir Residency</h6>
                    <p>The Rajgir Residency provides deluxe air-condition rooms include the following facilities</p>
                    <ul class="mb-30">
                      <li>Multi Cuisine Food</li>
                      <li>24 Hour Hot & Cold Shower</li>
                      <li>Multi-lingual satellite T.V.</li>
                      <li>Suite Rooms</li>
                      <li>24 Hour Uninterrupted Power Supply</li>
                      <li>Free High Speed Wi-Fi connectivity</li>
                      <li>Hair Dryer</li>
                      <li>Laundry Services</li>
                      <li>Shopping Arcade</li>
                      <li>Tea / Coffee maker</li>
                      <li>Doctor on call</li>
                      <li>Refrigerator</li>
                      <li>Room service</li>
                      <li>Parking facility</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    
    <section class="rooms5 section-padding bg-white" data-scroll-index="1">
        <div class="container">
            <div className="section-title">Room Type</div>
            <div class="row">
                <div class="col-lg-4 col-md-6 mb-30">
                    <div class="item">
                        <figure> <img src="img/rooms/r-room-1.jpg" loading="lazy" alt="hotel" class="img-fluid" /> </figure>
                        <div class="desc">
                            <h3 class="title"><Link to="#">Deluxe Single Room</Link></h3>
                              <div class="row room-facilities mb-15">
                                <div class="col-md-6 col-6">
                                    <ul>
                                        <li><i class="flaticon-group"></i> 1-2 Persons</li>
                                        <li><i class="flaticon-wifi"></i> Free Wifi</li>
                                    </ul>
                                </div>
                                <div class="col-md-6 col-6">
                                    <ul>
                                        <li><i class="flaticon-bed"></i> Single Bed</li>
                                        <li><i class="flaticon-breakfast"></i> Breakfast</li>
                                    </ul>
                                </div>
                            </div>
                             </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-30">
                    <div class="item">
                        <figure> <img src="img/rooms/r-room-2.jpg" loading="lazy" alt="hotel" class="img-fluid" /> </figure>
                        <div class="desc">
                            <h3 class="title"><Link to="#">Deluxe Twin / Double Room</Link></h3>
                            <div class="row room-facilities mb-15">
                                <div class="col-md-6 col-6">
                                    <ul>
                                        <li><i class="flaticon-group"></i> 1-2 Persons</li>
                                        <li><i class="flaticon-wifi"></i> Free Wifi</li>
                                    </ul>
                                </div>
                                <div class="col-md-6 col-6">
                                    <ul>
                                        <li><i class="flaticon-bed"></i> Twin Bed</li>
                                        <li><i class="flaticon-breakfast"></i> Breakfast</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-30">
                    <div class="item">
                        <figure> <img src="img/rooms/r-room-3.jpg" loading="lazy" alt="hotel" class="img-fluid" /> </figure>
                        <div class="desc">
                            <h3 class="title"><Link to="#">Suite Room</Link></h3>
                            <div class="row room-facilities mb-15">
                               <div class="col-md-6 col-6">
                                    <ul>
                                        <li><i class="flaticon-group"></i> 1-2 Persons</li>
                                        <li><i class="flaticon-wifi"></i> Free Wifi</li>
                                    </ul>
                                </div>
                                <div class="col-md-6 col-6">
                                    <ul>
                                        <li><i class="flaticon-bed"></i> Single Bed</li>
                                        <li><i class="flaticon-breakfast"></i> Breakfast</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                
            </div>
        </div>
        <div class="container">
                    <div class="row">
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-1.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-1.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-a.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-a.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-b.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-b.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-c.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-c.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-d.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-d.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-2.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-2.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-3.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-3.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-4.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-4.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-5.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-5.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-6.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-6.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-7.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-7.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-8.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-8.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-9.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-9.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-10.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-10.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-11.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-11.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-12.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-12.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-13.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-13.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-14.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-14.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-15.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-15.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-16.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-16.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-17.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-17.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-18.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-18.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div> */}
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-19.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-19.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-20.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-20.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-21.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-21.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-22.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-22.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-23.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-23.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-24.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-24.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-25.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-25.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-26.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-26.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div> */}
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-27.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-27.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/rajgir-28.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/rajgir-28.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        

                    </div>
                </div>
    </section>

     <section className="section-padding">
                    <div className="container">
                         <div className="section-title">Places of Attraction</div>
                         <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidencythumb}>
                        <div className="item thumb">
                            <img src='img/slider/Naturesafari.jpg' alt='' />
                            <p>Nature safari</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/ZooSafari.jpg' alt='' />
                            <p> Zoo Safari</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Griddhkuta.jpg' alt='' />
                            <p> Griddhkuta hills </p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Venuvan.jpg' alt='' />
                            <p>Venuvan</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Bimbisara.jpg' alt='' />
                            <p>Bimbisara jail</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Son.jpg' alt='' />
                            <p>Son bhandar</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Brahma.jpg' alt='' />
                            <p>Brahma kund</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Gurudwara.jpg' alt='' />
                            <p> Rajgir Gurudwara- sheetal kund</p>
                        </div>
                        
                        <div className="item thumb">
                            <img src='img/slider/Vishwashanti.jpg' alt='' />
                            <p>Vishwa shanti stupa and ropeway </p>
                        </div>
    
                  </OwlCarousel>
          
                    </div>
                </section>

<section class="bg-white">
      <div class="col-md-12">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.5160360331274!2d85.40711401504923!3d25.01655584514448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f2e56462577bff%3A0x71f1610d7326e944!2sThe+Rajgir+Residency+Hotel!5e0!3m2!1sen!2sin!4v1467014640801" width="100%" height="350" frameborder="0" class="mappie" allowfullscreen title="Google Map - The Rajgir Residency Hotel"></iframe>

        </div>

</section>

        </>
    )
};

export default RajgirResidency;
